import { Component, inject } from '@angular/core';
import { GS1LayoutModule, NotificationsComponent } from '@gs1france/gs1-components-library';
import { TranslateModule } from '@ngx-translate/core';
import { StorageService } from '@services/storage.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'header-comp',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],

  imports: [TranslateModule, GS1LayoutModule, NotificationsComponent]
})
export class HeaderComponent {
  private storageService = inject(StorageService);
  oauthService = inject(OAuthService);

  contactFullName: string = this.storageService.contactFullName;
  contactEmail: string = this.storageService.contactEmail;

  logout() {
    this.storageService.clearStorage();
    this.oauthService.logOut();
  }
}
